import * as S from "./InputWrapper.style";

const InputWrapper = ({ label, error, helperText, children, ...props }) => {
  return (
    <S.InputWrapper {...props}>
      {label && (
        <S.TextFieldLabel
          className={error ? "label-error" : undefined}
          variant="body-02-sm"
        >
          {label}
        </S.TextFieldLabel>
      )}
      {children}
      {helperText && (
        <S.TextFieldHelperText variant="caption-01">
          {helperText}
        </S.TextFieldHelperText>
      )}
      {!!error && <S.ErrorText variant="caption-01">{error}</S.ErrorText>}
    </S.InputWrapper>
  );
};

export default InputWrapper;
